<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="cotizaciones"
      :loading="loading"
      class="elevation-1"
      hide-actions
    >
      <v-progress-linear
        v-slot:progress
        color="blue"
        indeterminate
      ></v-progress-linear>
      <template v-slot:items="props">
        <td>{{ props.item.moneda }}</td>
        <td class="text-xs-right">{{ props.item.tipoCambio }}</td>
        <td class="text-xs-right">{{ props.item.tipoCambioZ }}</td>
        <td class="text-xs-right">{{ props.item.fecha }}</td>
      </template>
      <template v-slot:no-data>
        <v-alert :value="true" color="error" icon="warning">
          Sin datos :(
        </v-alert>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import AxiosHandler from "@/assets/js/class/AxiosHandler.js";
export default {
  name: "cotizacion",
  components: {},
  created() {},
  // mounted() {
  //   this.getCotizaciones();
  // },
  beforeCreate() {},
  methods: {
    async getCotizaciones() {
      this.loading = true;
      var header = this.$passporthandler.prepareHeader();
      if (!(typeof header.auth === "undefined")) {
        return;
      }
      let axios = new AxiosHandler();
      axios.setPassportHandler(this.$passporthandler);
      axios.prepare(
        process.env.VUE_APP_ASBACK + "/api/get-tipo-cambio",
        header
      );
      axios.overlay(false);
      await axios.exe();
      this.cotizaciones = axios.getData().cotizaciones;
      this.loading = false;
    }
  },
  data() {
    return {
      loading: false,
      cotizaciones: [],
      headers: [
        {
          text: "Moneda",
          align: "center",
          value: "moneda",
          sortable: false
        },
        {
          text: "Peso",
          align: "center",
          value: "tipoCambio",
          sortable: false
        },
        {
          text: "Dólar",
          align: "center",
          value: "tipoCambioZ",
          sortable: false
        },
        {
          text: "Cotización Válida hasta las 18:30 hs del dia",
          align: "center",
          value: "fecha",
          sortable: false
        }
      ]
    };
  }
};
</script>
<style scoped>
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
  text-align: center;
}

tr:nth-child(even) {
  background-color: #dddddd;
}
</style>
